import { Component } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
export interface ImageModal {
  title:string;
  message:string;
}
@Component({  
    selector: 'image-modal',
    template: `<div class="modal-dialog">
                <div class="modal-content">
                   <div class="modal-header">
                     <a (click)="close()" title="Close" class="close" style="cursor: pointer" data-dismiss="modal"></a>
                     <h4 class="modal-title">{{title || 'Confirm'}}</h4>
                   </div>
                   <div class="modal-body">
                     <p class="text-center">Please prepare scanned copies of your certified documents to your application.</p>
                     <br/>
                     <p class="text-center">Click on the image to zoom.</p>
                     <br/>
                     <a href="assets/DocumentsRequired.pdf" target="_blank">
                       <img src="assets/DocumentsRequired.png" class="img-responsive" alt="Image">
                     </a>
                   </div>
                 </div>
              </div>`
})
export class ImageModalComponent extends DialogComponent<ImageModal, string> implements ImageModal {
  title: string;
  message: string;
  constructor(dialogService: DialogService) {
    super(dialogService);
  }
  // confirm() {
  //   // we set dialog result as true on click on confirm button, 
  //   // then we can get dialog result from caller code 
  //   this.result = "hello";
  //   this.close();
  // }
}